export default "__VITE_ASSET__CdnpOA_s__"